let is_script_triggered_bold = false;
document.addEventListener('cart:updated', (e) => {
    console.log('Event emitted', e.detail.cart);
    setTimeout(() => {
        if (is_script_triggered_bold) return
        is_script_triggered_bold = true;
        if (BOLD && BOLD.options && BOLD.options.app && BOLD.options.app.cartDoctor) {
            BOLD.options.app.cartDoctor.cart = e.detail.cart;
            BOLD.options.app.cartDoctor.rawCart = e.detail.cart;
            BOLD.options.app.cartDoctor.platformCart = e.detail.cart;
            BOLD.options.app.cartHandler.addEditInCart();
            window.requestAnimationFrame(()=>{
                const editInCarts = document.querySelectorAll('.bold_cart_edit_button');
                editInCarts.forEach((btn)=>{
                    if (!btn.dataset.lineId){
                        const lineItem = btn.parentElement.dataset.lineId;
                        if (lineItem){
                            btn.setAttribute('data-line-id',lineItem);
                        }
                    }
                })
            })
        }
    },1000);
})